import { render } from "./ServicesStyleTwoPage.vue?vue&type=template&id=b6733672"
import script from "./ServicesStyleTwoPage.vue?vue&type=script&lang=js"
export * from "./ServicesStyleTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__